import React from 'react'
import { Link } from 'gatsby'

import { Image } from 'src/components/image'
import { SmallArrow } from 'src/components/svgs'
import './locationCard.module.css'
import classes from './locationCard.module.css'
import { useMediaQuery } from 'src/hooks/useMediaQuery'
import { trackWebsiteCtaClicked } from 'src/utils/ctaTracking'

interface LocationService {
  id: string
  content: {
    main: {
      title: string
      slug: {
        current: string
      }
    }
  }
}

interface LocationImage {
  asset: {
    _id: string
  }
}

interface LocationContent {
  main: {
    enableLanding: boolean
    title: string
    address: string
    ctaText?: string
    image?: LocationImage
    logo?: LocationImage
    badge?: string
    services?: LocationService[]
    slug: {
      current: string
    }
  }
}

interface LocationCardProps {
  content: LocationContent
  horizontal?: boolean
}

export const LocationCard: React.FC<LocationCardProps> = ({
  content: {
    main: {
      title,
      address,
      image,
      logo,
      enableLanding,
      ctaText,
      badge,
      services,
      slug,
    },
  },
  horizontal,
}) => {
  const { isMobileDevice } = useMediaQuery()

  const finalSlug = `/locations/${slug.current}/`

  return (
    <React.Fragment>
      <div
        className={`location__card ${
          horizontal ? classes.horizontal : ''
        } bcw rel cb f aist ${classes.locationCard}`}
      >
        {enableLanding && (
          <Link className="abs z2 x y top left" to={finalSlug} />
        )}
        {image && image?.asset?._id && (
          <div className={`x rel ${classes.imageContainer}`}>
            {badge && (
              <div className={`${classes.badgeContainer} abs ps20 left z1 top`}>
                <span
                  className={`px1 py05 br5 caps mono cw bg-primary-3 ${classes.badgeText}`}
                >
                  {badge}
                </span>
              </div>
            )}
            <Image className="x" imageId={image.asset._id} alt={title} />
          </div>
        )}
        <div
          className={`location__card-info x rel z3 px1 ${classes.cardInfo} ${classes.cardInfoLayout}`}
        >
          <div className={classes.contentContainer}>
            {enableLanding ? (
              <Link className="" to={`/locations/${slug.current}/`}>
                <h3 className={`mb20 ${classes.subTitle}`}>{title}</h3>
              </Link>
            ) : (
              <h3 className="mb20">{title}</h3>
            )}
            <p
              className={classes.paragraph}
              dangerouslySetInnerHTML={{
                __html: address?.replace(/\n/gi, '<br />'),
              }}
            />
            {services && services.length > 0 && (
              <div className={`s18 ${classes.servicesLines}`}>
                <span className="bold">Services:</span>{' '}
                {services?.map((service, i) => (
                  <React.Fragment key={service.id}>
                    <Link
                      className="underline"
                      to={`/services/${service.content.main.slug.current}/`}
                    >
                      {service.content.main.title}
                    </Link>
                    {services.length > i + 1 && ', '}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
          <div
            className={`${horizontal ? classes.bottomContainer : ''} ${
              classes.seeDetails
            }`}
          >
            <div className="pb30">
              {enableLanding && (
                <Link
                  className="f aic s18 bold"
                  to={finalSlug}
                  onClick={() =>
                    trackWebsiteCtaClicked({
                      ctaText: ctaText || 'See clinic details',
                      module: 'Location card',
                      heading: title,
                      targetUrl: finalSlug,
                    })
                  }
                >
                  <span
                    className={`${classes.underline} ${
                      isMobileDevice ? '' : 'mr15'
                    }`}
                  >
                    {ctaText ? ctaText : 'See clinic details'}
                  </span>{' '}
                  <SmallArrow />
                </Link>
              )}
            </div>
            {logo && logo?.asset?._id && (
              <div
                className={`${classes.logoContainer} insurance__module-single`}
              >
                <Image imageId={logo.asset._id} />
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
